import { KeyboardEvent } from 'react';

export const NON_INTEGER_INPUT_KEYS = ['.', ',', 'e', 'E', '+', '-'];

export const runOnActivationKey = (event: KeyboardEvent, action: () => void) => {
  if (event.key !== 'Enter' && event.key !== ' ') {
    return;
  }

  event.preventDefault();

  if (!event.repeat) {
    action();
  }
};
